export interface ComicChapter {
  id: number;
  title: string;
  chapterNumber: number;
  pageCount: number;
  updateDate: string;
}

export interface ComicData {
  id: number;
  slug: string;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  status: string;
  coverImage: string;
  description: string;
  rating: number;
  views: number;
  favorites: number;
  tags: string[];
  chapters: ComicChapter[];
  updateDate: string;
  isFeatured: boolean;
  isHot: boolean;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '热血', slug: 'rexue' },
  { name: '恋爱', slug: 'lianai' },
  { name: '搞笑', slug: 'gaoxiao' },
  { name: '奇幻', slug: 'qihuan' },
  { name: '悬疑', slug: 'xuanyi' },
  { name: '科幻', slug: 'kehuan' },
  { name: '日常', slug: 'richang' },
  { name: '恐怖', slug: 'kongbu' },
  { name: '冒险', slug: 'maoxian' },
];

export const comics: ComicData[] = [
  {
    id: 1,
    slug: 'dongdong-zahuopu',
    title: '洞洞杂货铺',
    author: '林小夕',
    category: '悬疑',
    categorySlug: 'xuanyi',
    status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Chinese%20manga%20cover%20featuring%20a%20small%20cozy%20variety%20shop%20at%20dusk%20with%20warm%20golden%20light%20spilling%20from%20windows%2C%20a%20young%20woman%20standing%20at%20the%20doorway%2C%20mystical%20atmosphere%2C%20slightly%20surreal%20elements%2C%20soft%20illustration%20style%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20clean%20background&width=600&height=800&seq=dongdong-cover-01&orientation=portrait',
    description: '在城市的一条老街上，有一家不起眼的杂货铺。店主是一位神秘的年轻女子，她售卖的不是普通商品，而是能够解决人们烦恼的"特殊物品"。每一件物品背后，都藏着一个不为人知的故事。当顾客走进这家杂货铺，他们的命运便开始悄然改变……',
    rating: 9.6,
    views: 1285000,
    favorites: 325000,
    tags: ['悬疑', '治愈', '奇幻', '单元剧', '都市传说'],
    chapters: [
      { id: 1, title: '第一话：不速之客', chapterNumber: 1, pageCount: 42, updateDate: '2026-01-15' },
      { id: 2, title: '第二话：遗忘的戒指', chapterNumber: 2, pageCount: 38, updateDate: '2026-01-22' },
      { id: 3, title: '第三话：镜中的影子', chapterNumber: 3, pageCount: 45, updateDate: '2026-01-29' },
      { id: 4, title: '第四话：午夜钟声', chapterNumber: 4, pageCount: 40, updateDate: '2026-02-05' },
      { id: 5, title: '第五话：消失的第七天', chapterNumber: 5, pageCount: 44, updateDate: '2026-02-12' },
      { id: 6, title: '第六话：雨夜的约定', chapterNumber: 6, pageCount: 41, updateDate: '2026-02-19' },
      { id: 7, title: '第七话：不存在的楼层', chapterNumber: 7, pageCount: 39, updateDate: '2026-02-26' },
      { id: 8, title: '第八话：旧照片', chapterNumber: 8, pageCount: 43, updateDate: '2026-03-05' },
      { id: 9, title: '第九话：风铃的回音', chapterNumber: 9, pageCount: 37, updateDate: '2026-03-12' },
      { id: 10, title: '第十话：最后的交易', chapterNumber: 10, pageCount: 46, updateDate: '2026-03-19' },
      { id: 11, title: '第十一话：新的开始', chapterNumber: 11, pageCount: 40, updateDate: '2026-03-26' },
      { id: 12, title: '第十二话：暗流涌动', chapterNumber: 12, pageCount: 44, updateDate: '2026-04-02' },
      { id: 13, title: '第十三话：门后的世界', chapterNumber: 13, pageCount: 42, updateDate: '2026-04-09' },
      { id: 14, title: '第十四话：时间的缝隙', chapterNumber: 14, pageCount: 38, updateDate: '2026-04-16' },
      { id: 15, title: '第十五话：重逢', chapterNumber: 15, pageCount: 45, updateDate: '2026-04-23' },
      { id: 16, title: '第十六话：真相浮现', chapterNumber: 16, pageCount: 41, updateDate: '2026-04-30' },
      { id: 17, title: '第十七话：抉择', chapterNumber: 17, pageCount: 43, updateDate: '2026-05-07' },
      { id: 18, title: '第十八话：黎明之前', chapterNumber: 18, pageCount: 40, updateDate: '2026-05-14' },
      { id: 19, title: '第十九话：命运的交汇', chapterNumber: 19, pageCount: 44, updateDate: '2026-05-21' },
      { id: 20, title: '第二十话：杂货铺的秘密', chapterNumber: 20, pageCount: 47, updateDate: '2026-05-28' },
    ],
    updateDate: '2026-05-28',
    isFeatured: true,
    isHot: true,
  },
  {
    id: 2,
    slug: 'xingkong-wudizhe',
    title: '星空舞者',
    author: '陈星河',
    category: '热血',
    categorySlug: 'rexue',
    status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20anime%20manga%20cover%20of%20a%20young%20dancer%20leaping%20through%20a%20starry%20night%20sky%2C%20energy%20ribbons%20flowing%20around%2C%20vibrant%20warm%20colors%2C%20action%20pose%2C%20clean%20illustration%20style%20on%20simple%20dark%20background&width=600&height=800&seq=xingkong-cover-02&orientation=portrait',
    description: '少年林星辰梦想成为世界上最强的舞者。在偶然获得一本神秘的舞谱后，他发现舞蹈中蕴含着不可思议的力量。从此，他踏上了用舞蹈对抗黑暗势力的热血之旅。',
    rating: 9.2,
    views: 980000,
    favorites: 215000,
    tags: ['热血', '舞蹈', '超能力', '竞技', '成长'],
    chapters: [
      { id: 21, title: '第一话：梦想的起点', chapterNumber: 1, pageCount: 38, updateDate: '2026-05-20' },
      { id: 22, title: '第二话：神秘舞谱', chapterNumber: 2, pageCount: 41, updateDate: '2026-05-27' },
    ],
    updateDate: '2026-05-27',
    isFeatured: false,
    isHot: true,
  },
  {
    id: 3,
    slug: 'yinghua-luoxia',
    title: '樱花落下的季节',
    author: '夏小满',
    category: '恋爱',
    categorySlug: 'lianai',
    status: '已完结',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20romance%20manga%20cover%20depicting%20two%20teenagers%20under%20a%20blooming%20cherry%20blossom%20tree%20in%20spring%2C%20soft%20pink%20petals%20falling%2C%20gentle%20warm%20lighting%2C%20sweet%20atmosphere%2C%20clean%20illustration%20style%20on%20soft%20cream%20background&width=600&height=800&seq=yinghua-cover-03&orientation=portrait',
    description: '转学到樱花镇的苏小暖，在樱花纷飞的季节遇见了温柔学长顾言。两个性格迥异的人，从最初的误会到逐渐靠近，谱写了一段青春最美的乐章。',
    rating: 9.4,
    views: 1560000,
    favorites: 420000,
    tags: ['恋爱', '校园', '青春', '治愈', '纯爱'],
    chapters: [
      { id: 31, title: '第一话：转学生', chapterNumber: 1, pageCount: 36, updateDate: '2025-09-01' },
      { id: 32, title: '第二话：樱花树下', chapterNumber: 2, pageCount: 39, updateDate: '2025-09-08' },
    ],
    updateDate: '2026-04-30',
    isFeatured: true,
    isHot: false,
  },
  {
    id: 4,
    slug: 'jiong-riji',
    title: '囧日记',
    author: '王大锤',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20funny%20comedy%20manga%20cover%20showing%20a%20chubby%20office%20worker%20with%20exaggerated%20facial%20expression%20in%20embarrassing%20situations%2C%20bright%20warm%20colors%2C%20humorous%20cartoon%20style%2C%20simple%20clean%20background&width=600&height=800&seq=jiong-cover-04&orientation=portrait',
    description: '一个普通上班族的爆笑日常。从挤地铁到开会打瞌睡，从相亲失败到外卖被偷，每一页都能让你笑出腹肌！生活虽然艰难，但我们可以笑着面对。',
    rating: 9.1,
    views: 2150000,
    favorites: 580000,
    tags: ['搞笑', '日常', '职场', '生活', '四格'],
    chapters: [
      { id: 41, title: '第一话：上班第一天', chapterNumber: 1, pageCount: 24, updateDate: '2026-04-01' },
      { id: 42, title: '第二话：地铁惊魂', chapterNumber: 2, pageCount: 26, updateDate: '2026-04-08' },
    ],
    updateDate: '2026-05-25',
    isFeatured: false,
    isHot: true,
  },
  {
    id: 5,
    slug: 'yijie-shangren',
    title: '异界商人',
    author: '墨白',
    category: '奇幻',
    categorySlug: 'qihuan',
    status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fantasy%20manga%20cover%20featuring%20a%20merchant%20in%20medieval%20fantasy%20clothing%20standing%20in%20a%20magical%20marketplace%2C%20floating%20crystals%20and%20mystical%20items%20around%2C%20warm%20golden%20atmosphere%2C%20detailed%20illustration%20on%20simple%20background&width=600&height=800&seq=yijie-cover-05&orientation=portrait',
    description: '穿越到异世界的普通销售员发现，自己的口才在这个世界成了一种超能力。用现代商业思维碾压魔法世界，打造属于他的商业帝国！',
    rating: 9.3,
    views: 890000,
    favorites: 195000,
    tags: ['奇幻', '穿越', '商业', '冒险', '异能'],
    chapters: [
      { id: 51, title: '第一话：穿越异世界', chapterNumber: 1, pageCount: 40, updateDate: '2026-05-10' },
      { id: 52, title: '第二话：第一次交易', chapterNumber: 2, pageCount: 42, updateDate: '2026-05-17' },
    ],
    updateDate: '2026-05-24',
    isFeatured: false,
    isHot: true,
  },
  {
    id: 6,
    slug: 'heian-bishou',
    title: '黑暗庇护所',
    author: '夜不语',
    category: '恐怖',
    categorySlug: 'kongbu',
    status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20horror%20manga%20cover%20showing%20an%20abandoned%20building%20with%20a%20single%20lit%20window%2C%20eerie%20shadows%2C%20creepy%20atmosphere%2C%20dark%20warm%20tones%2C%20ominous%20mood%2C%20clean%20illustration%20style&width=600&height=800&seq=heian-cover-06&orientation=portrait',
    description: '一座废弃的精神病院里，每到午夜就会传出奇怪的声音。五个大学生为了一探究竟闯入其中，却发现了比想象中更加恐怖的事实……',
    rating: 8.9,
    views: 720000,
    favorites: 150000,
    tags: ['恐怖', '悬疑', '灵异', '校园', '生存'],
    chapters: [
      { id: 61, title: '第一话：废弃病院', chapterNumber: 1, pageCount: 44, updateDate: '2026-05-15' },
      { id: 62, title: '第二话：午夜怪声', chapterNumber: 2, pageCount: 42, updateDate: '2026-05-22' },
    ],
    updateDate: '2026-05-29',
    isFeatured: false,
    isHot: false,
  },
  {
    id: 7,
    slug: 'xingji-langren',
    title: '星际浪人',
    author: '赵星辰',
    category: '科幻',
    categorySlug: 'kehuan',
    status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20manga%20cover%20depicting%20a%20lone%20wanderer%20in%20a%20futuristic%20spacesuit%20standing%20on%20an%20alien%20planet%20with%20twin%20suns%20setting%2C%20epic%20scale%2C%20warm%20orange%20and%20gold%20tones%2C%20clean%20illustration&width=600&height=800&seq=xingji-cover-07&orientation=portrait',
    description: '公元2250年，人类已经遍布银河系。退役老兵秦风驾驶着一艘破旧的飞船，在各个星球之间流浪。每一颗星球都是一段故事，每一次停靠都是一场冒险。',
    rating: 9.5,
    views: 1100000,
    favorites: 280000,
    tags: ['科幻', '太空', '冒险', '机甲', '硬核'],
    chapters: [
      { id: 71, title: '第一话：退役之日', chapterNumber: 1, pageCount: 38, updateDate: '2026-04-20' },
      { id: 72, title: '第二话：破旧飞船', chapterNumber: 2, pageCount: 41, updateDate: '2026-04-27' },
    ],
    updateDate: '2026-05-26',
    isFeatured: true,
    isHot: false,
  },
  {
    id: 8,
    slug: 'maoxian-wang',
    title: '冒险王',
    author: '张大勇',
    category: '冒险',
    categorySlug: 'maoxian',
    status: '已完结',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20adventure%20manga%20cover%20showing%20a%20young%20explorer%20with%20backpack%20climbing%20ancient%20ruins%20in%20a%20dense%20jungle%2C%20golden%20sunlight%20through%20leaves%2C%20treasure%20map%20in%20hand%2C%20warm%20earthy%20tones%2C%20clean%20illustration&width=600&height=800&seq=maoxian-cover-08&orientation=portrait',
    description: '少年阿勇意外获得一张藏宝图，踏上了环游世界的冒险之旅。从埃及金字塔到亚马逊丛林，从深海遗迹到天空之城，每一站都是惊心动魄的挑战。',
    rating: 9.0,
    views: 1350000,
    favorites: 350000,
    tags: ['冒险', '寻宝', '世界旅行', '友情', '热血'],
    chapters: [
      { id: 81, title: '第一话：藏宝图', chapterNumber: 1, pageCount: 35, updateDate: '2025-06-01' },
      { id: 82, title: '第二话：出发', chapterNumber: 2, pageCount: 37, updateDate: '2025-06-08' },
    ],
    updateDate: '2026-05-15',
    isFeatured: false,
    isHot: false,
  },
  {
    id: 9,
    slug: 'mao-rikui',
    title: '猫的日常',
    author: '橙子酱',
    category: '日常',
    categorySlug: 'richang',
    status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cute%20slice%20of%20life%20manga%20cover%20showing%20a%20fluffy%20orange%20cat%20lounging%20on%20a%20sunny%20windowsill%20with%20cozy%20room%20interior%2C%20soft%20warm%20lighting%2C%20peaceful%20atmosphere%2C%20gentle%20illustration%20style&width=600&height=800&seq=mao-cover-09&orientation=portrait',
    description: '一只名叫团子的橘猫和它的主人之间的温馨日常。从早上的踩脸叫醒服务到深夜的暗中观察，每一页都充满了猫奴们熟悉的治愈瞬间。',
    rating: 9.7,
    views: 1850000,
    favorites: 520000,
    tags: ['日常', '治愈', '猫咪', '温馨', '生活'],
    chapters: [
      { id: 91, title: '第一话：新成员', chapterNumber: 1, pageCount: 28, updateDate: '2026-04-10' },
      { id: 92, title: '第二话：踩脸闹钟', chapterNumber: 2, pageCount: 30, updateDate: '2026-04-17' },
    ],
    updateDate: '2026-05-23',
    isFeatured: false,
    isHot: true,
  },
  {
    id: 10,
    slug: 'shiyi-zhentanshe',
    title: '十一侦探社',
    author: '苏眠',
    category: '悬疑',
    categorySlug: 'xuanyi',
    status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mystery%20manga%20cover%20showing%20a%20young%20detective%20in%20trench%20coat%20holding%20a%20magnifying%20glass%20in%20a%20dimly%20lit%20office%2C%20case%20files%20scattered%2C%20noir%20atmosphere%2C%20warm%20sepia%20tones%2C%20clean%20illustration&width=600&height=800&seq=shiyi-cover-10&orientation=portrait',
    description: '在城市的第十一号街区，有一家不起眼的侦探社。社长苏眠是个智商超群但性格古怪的年轻人。每一个委托都看似简单，背后却隐藏着令人意想不到的真相。',
    rating: 9.3,
    views: 950000,
    favorites: 210000,
    tags: ['悬疑', '推理', '侦探', '都市', '智斗'],
    chapters: [
      { id: 101, title: '第一话：奇怪的委托', chapterNumber: 1, pageCount: 40, updateDate: '2026-05-01' },
      { id: 102, title: '第二话：失踪的钟表', chapterNumber: 2, pageCount: 42, updateDate: '2026-05-08' },
    ],
    updateDate: '2026-05-22',
    isFeatured: false,
    isHot: false,
  },
  {
    id: 11,
    slug: 'liehuo-jianhun',
    title: '烈火剑魂',
    author: '剑无心',
    category: '热血',
    categorySlug: 'rexue',
    status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20action%20manga%20cover%20showing%20a%20swordsman%20with%20flaming%20sword%20in%20battle%20stance%2C%20fire%20effects%2C%20dynamic%20composition%2C%20intense%20warm%20colors%2C%20dramatic%20lighting%2C%20clean%20illustration%20on%20simple%20dark%20background&width=600&height=800&seq=liehuo-cover-11&orientation=portrait',
    description: '在剑道衰落的世界里，少年凌炎继承了失传的烈火剑法。为了重振剑道荣光，他踏上了挑战天下高手的征途。一剑既出，烈火燎原！',
    rating: 9.4,
    views: 1050000,
    favorites: 260000,
    tags: ['热血', '剑道', '武道', '竞技', '成长'],
    chapters: [
      { id: 111, title: '第一话：剑道少年', chapterNumber: 1, pageCount: 39, updateDate: '2026-04-25' },
      { id: 112, title: '第二话：烈火初现', chapterNumber: 2, pageCount: 42, updateDate: '2026-05-02' },
    ],
    updateDate: '2026-05-23',
    isFeatured: false,
    isHot: true,
  },
  {
    id: 12,
    slug: 'tianshi-zhiyue',
    title: '天使之约',
    author: '月玲珑',
    category: '恋爱',
    categorySlug: 'lianai',
    status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20fantasy%20manga%20cover%20showing%20a%20girl%20with%20angel%20wings%20meeting%20a%20human%20boy%20on%20a%20rooftop%20at%20sunset%2C%20golden%20hour%20lighting%2C%20dreamy%20atmosphere%2C%20warm%20soft%20colors%2C%20clean%20illustration&width=600&height=800&seq=tianshi-cover-12&orientation=portrait',
    description: '高中生林小朵偶然救下了一个从天而降的少年，没想到他竟然是来自天界的见习天使。为了完成在人间的试炼，他必须守护她直到心愿实现……',
    rating: 9.1,
    views: 820000,
    favorites: 185000,
    tags: ['恋爱', '奇幻', '校园', '天使', '日常'],
    chapters: [
      { id: 121, title: '第一话：天降少年', chapterNumber: 1, pageCount: 37, updateDate: '2026-05-05' },
      { id: 122, title: '第二话：守护约定', chapterNumber: 2, pageCount: 39, updateDate: '2026-05-12' },
    ],
    updateDate: '2026-05-19',
    isFeatured: false,
    isHot: false,
  },
];

export const featuredComics = comics.filter((c) => c.isFeatured);
export const hotComics = comics.filter((c) => c.isHot);
export const latestComics = [...comics].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime());

export function getComicBySlug(slug: string): ComicData | undefined {
  return comics.find((c) => c.slug === slug);
}

export function getComicsByCategory(categorySlug: string): ComicData[] {
  if (categorySlug === 'all') return comics;
  return comics.filter((c) => c.categorySlug === categorySlug);
}

export function getRelatedComics(comic: ComicData, count: number = 4): ComicData[] {
  return comics
    .filter((c) => c.id !== comic.id && (c.categorySlug === comic.categorySlug || c.tags.some((t) => comic.tags.includes(t))))
    .sort(() => 0.5 - Math.random())
    .slice(0, count);
}